module.exports = __webpack_public_path__ + "static/media/cover-mobile.6e0a9dc7.jpg";